import moment from "jalali-moment";
import html2canvas from "html2canvas";

const config = {
  parseFloat: (number, tofixNum) => {
    return number !== 0 ? parseFloat(number).toFixed(tofixNum || 2) : 0;
  },
  numberSeparator: (number) => {
    return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  sortArray: (array, key) => {
    if (array) {
      let arrayCopy = [...array];
      return arrayCopy?.sort((a, b) => a[key] - b[key]);
    }
  },
  removeDuplicateItemInArray: (input, key) => {
    return input?.filter((item, index, array) => {
      return (
        array.findIndex((otherItem) => otherItem[key] === item[key]) === index
      );
    });
  },
  converToPersianDate: (date) => {
    if (date) return moment(date).locale("fa").format("YYYY/MM/DD");
  },
  converToPersianDateTime: (date) => {
    if (date) return moment(date).locale("fa").format("YYYY/MM/DD • HH:mm");
  },
  converToPersianAlphabetDate: (date) => {
    if (date)
      return new Date(date).toLocaleDateString("fa", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
  },
  converToPersianShortDate: (date) => {
    if (date) return moment(date).locale("fa").format("YY/M/DD");
  },
  converToGlobalDate: (date) => {
    if (date) return moment(date, "jYYYY/jM/jD").format("YYYY-MM-DD");
  },
  getOneYearBefore: () => {
    return moment().subtract(1, "year").format("YYYY/MM/DD");
  },
  getThreeMonthBefore: () => {
    return moment().subtract(3, "months").format("YYYY-MM-DD");
  },

  getSixMonthBefore: () => {
    return moment().subtract(6, "months").format("YYYY-MM-DD");
  },
  getYesterday: () => {
    return moment().subtract(1, "days").format("YYYY-MM-DD");
  },
  getToday: () => {
    return moment().format("YYYY-MM-DD");
  },
  getTenMonthBefore: () => {
    return moment().subtract(10, "months").format("YYYY-MM-DD");
  },
  getOneMonthBefore: () => {
    return moment().subtract(1, "months").format("YYYY-MM-DD");
  },
  totalNumberOf: (array, arrayItem) => {
    return array?.reduce(
      (accum, item) => Number(accum) + Number(item[arrayItem]),
      0
    );
  },
  base64toFile: async ({
    elementById = "content",
    filename = "image",
    mimeType = "image/png",
    isDownloadFail = false,
  }) => {
    const content = document.getElementById(elementById);
    const canvas = await html2canvas(content);
    const base64 = canvas.toDataURL();

    // Remove the data URL prefix
    const base64Data = base64?.replace(/^data:\w+\/\w+;base64,/, "");

    // Convert the base64 string to binary data
    const binaryData = atob(base64Data);

    // Create an ArrayBuffer from the binary data
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob object from the ArrayBuffer
    const blob = new Blob([arrayBuffer], { type: mimeType });

    // Create a File object from the Blob
    const file = new File([blob], filename, { type: mimeType });

    if (
      !isDownloadFail &&
      navigator.canShare &&
      navigator.canShare({ files: [file] })
    ) {
      try {
        await navigator.share({ title: "", text: "", files: [file] });
      } catch (error) {
        console.error("Error sharing the file:", error);
      }
    } else {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    }
  },
};

export default config;
